import { useMemo, useCallback } from "react";
import { Dispatch, AnyAction } from "redux";
import { useSelector, useDispatch } from "react-redux";

import { authActions } from "../../store/auth/actions";
import { ApplicationState } from "../../store/RootReducers";
import { LoginState } from "../../store/auth/state";
import { LoginRequest } from "../../services/authService/AuthService.type";
import authService from "../../services/authService/AuthService";
import sessionStorage from "../../services/SessionStorage";

import useAPI from "../../helperHooks/useAPI";
import { applicationActions } from "../../store/application/actions";

interface Selectors {
  loginState: LoginState;
}
interface ActionDispatchers {
  login: (
    data: LoginRequest,
    redirectTo?: (route: string, reLogging: boolean) => void
  ) => void;
  setLoginIssuePhoneNumber: (phoneNumber: string) => void;
}

/**
 * @description accesses Redux, returns required state,actions
 *
 * @returns {(Selectors & ActionDispatchers)}
 */
const useAuth = () => {
  const dispatch = useDispatch<Dispatch<AnyAction>>();
  const selectors = useSelector(stateSelector);

  const actionDispatchers = useMemo(() => actions(dispatch), [dispatch]);

  const { callAPI: triggerLogout, loading: loggingOut } = useAPI(
    authService.logout
  );

  const logout = useCallback(() => {
    triggerLogout({}, () => {
      sessionStorage.clearAll();

      dispatch(applicationActions.flushData());
    });
  }, [dispatch, triggerLogout]);

  return { ...selectors, ...actionDispatchers, logout, loggingOut };
};

const stateSelector = (state: ApplicationState): Selectors => ({
  loginState: state.loginState
});

const actions = (dispatch: Dispatch<AnyAction>): ActionDispatchers => ({
  login: (
    data: LoginRequest,
    redirectTo?: (route: string, reLogging: boolean) => void
  ) => {
    dispatch(authActions.login.started({ data, redirectTo }));
  },
  setLoginIssuePhoneNumber: (phoneNumber: string) => {
    dispatch(authActions.setIssuePhoneNumber({ phoneNumber, fromLogin: true }));
  }
});

export default useAuth;
